const allSourceFields = {
  poalim: {
    sourceName: 'הפועלים',
    displayName: 'בנק הפועלים',
    backendName: 'poalim',
    sortPriority: 10,
    fields: {
      username: {
        key: 'username',
        name: 'קוד משתמש',
        type: 'text',
        validation: 'min-length:6|not-he',
      },
      password: {
        key: 'password',
        name: 'סיסמה קבועה',
        type: 'password',
        renew: true,
        validation: 'min-length:8|not-he',
      },
    },
    links: {
      homepage: 'https://www.bankhapoalim.co.il',
      login: 'https://login.bankhapoalim.co.il/cgi-bin/poalwwwc?reqName=getLogonPage',
      signup: 'https://join.bankhapoalim.co.il/reg/Np/main.jsp',
    },
    logoFile: 'hapoalim-large.svg',
    type: 'bank',
  },
  discount: {
    sourceName: 'דיסקונט',
    displayName: 'דיסקונט',
    backendName: 'DiscountBank',
    sortPriority: 10,
    fields: {
      idNumber: {
        key: 'idNumber',
        name: 'מספר זהות',
        type: 'text',
        validation: 'id',
      },
      password: {
        key: 'password',
        name: 'סיסמה קבועה',
        type: 'password',
        renew: true,
        validation: 'min-length:6|not-he',
      },
      identityCode: {
        key: 'identityCode',
        name: 'קוד מזהה',
        type: 'text',
        validation: 'not-he',
      },
    },
    links: {
      homepage: 'https://www.discountbank.co.il',
      login: 'https://www.discountbank.co.il/DB/private',
      signup: 'https://www.discountbank.co.il/DB/private/join',
    },
    logoFile: 'discount-large.svg',
    instructions: 'Discount.vue',
    type: 'bank',
    hidden: true,
  },
  'discount-api': {
    sourceName: 'דיסקונט ישיר',
    displayName: 'דיסקונט ישיר',
    backendName: 'discountApi',
    sortPriority: 10,
    fields: {
      idNumber: {
        key: 'idNumber',
        name: 'מספר זהות',
        type: 'text',
        validation: 'id',
      },
    },
    links: {
      homepage: 'https://www.discountbank.co.il',
      login: 'https://www.discountbank.co.il/DB/private',
      signup: 'https://www.discountbank.co.il/DB/private/join',
    },
    logoFile: 'discount-large.svg',
    instructions: 'DiscountApi.vue',
    type: 'bank',
  },
  leumi: {
    sourceName: 'לאומי',
    displayName: 'לאומי',
    sortPriority: 10,
    backendName: 'leumiBank',
    fields: {
      username: {
        key: 'username',
        name: 'זיהוי משתמש',
        type: 'text',
        validation: 'exact-length:7|not-he|not-special',
      },
      password: {
        key: 'password',
        name: 'סיסמה קבועה',
        type: 'password',
        renew: true,
        validation: 'min-length:6|not-he',
      },
    },
    links: {
      homepage: 'https://www.leumi.co.il',
      login: 'https://hb2.bankleumi.co.il/uniquesig4e0824291ffbe1b42058d6558ed87217/uniquesig0/InternalSite/CustomUpdate/eBank_ULI_Login.asp?resource_id=C66B095BD60649D18ECB79F04C657517&login_type=2&site_name=leumi&secure=1&URLHASH=14b6a749-0795-469f-b880-0752d25aab16&orig_url=https%3a%2f%2fhb2.bankleumi.co.il%2fH%2fLogin.html%3fblga%3d457807548.1539249230', // eslint-disable-line
    },
    logoFile: 'leumi-large.svg',
    type: 'bank',
  },
  mercantil: {
    sourceName: 'מרכנתיל',
    displayName: 'מרכנתיל',
    backendName: 'MercantileBank',
    sortPriority: 50,
    fields: {
      idNumber: {
        key: 'idNumber',
        name: 'מספר זהות',
        type: 'text',
        validation: 'id',
      },
      password: {
        key: 'password',
        name: 'סיסמה קבועה',
        type: 'password',
        renew: true,
        validation: 'min-length:6|not-he',
      },
      identityCode: {
        key: 'identityCode',
        name: 'קוד מזהה',
        type: 'text',
        validation: 'not-he',
      },
    },
    links: {
      homepage: 'https://www.mercantile.co.il',
      login: 'https://www.mercantile.co.il/MB/private/',
      signup: 'https://www.mercantile.co.il/MB/private/join-internet',
    },
    logoFile: 'mercantile-large.png',
    type: 'bank',
  },
  mizrahi: {
    sourceName: 'מזרחי',
    displayName: 'מזרחי טפחות',
    backendName: 'mizrahi',
    sortPriority: 50,
    fields: {
      username: {
        key: 'username',
        name: 'מספר משתמש',
        type: 'text',
        validation: 'not-he|not-special',
      },
      password: {
        key: 'password',
        name: 'סיסמה קבועה',
        type: 'password',
        renew: true,
        validation: 'min-length:6|not-he',
      },
    },
    links: {
      homepage: 'https://www.mizrahi-tefahot.co.il',
      login: 'https://www.mizrahi-tefahot.co.il/login/LoginMTO.aspx?errorcode=198&TYPE=100663297&REALMOID=06-379e9a46-0ea8-4ab6-8ab1-880e6888203e&GUID=&SMAUTHREASON=0&METHOD=GET&SMAGENTNAME=$SM$e7C0GBhQlQIsjzKU1bTHYzA0SjkxVktpnumjMG0JJY5aUBhHzLoziO%2fUD5Ind0FI&TARGET=$SM$HTTP%3a%2f%2fmto%2emizrahi-tefahot%2eco%2eil%2fOnline%2fDefault%2easpx%3flanguage%3dhe-IL%26page%3d~%2fIC%2fP946%2easpx', // eslint-disable-line
    },
    logoFile: 'mizrachi-large.svg',
    type: 'bank',
  },
  yahav: {
    sourceName: 'יהב',
    displayName: 'בנק יהב',
    backendName: 'YahavBank',
    waitingListName: 'Yahav',
    sortPriority: 100,
    fields: {
      userName: {
        key: 'userName',
        name: 'שם משתמש',
        type: 'text',
        validation: 'not-he',
      },
      idNumber: {
        key: 'idNumber',
        name: 'תעודת זהות (9 ספרות)',
        type: 'text',
        validation: 'id',
      },
      password: {
        key: 'password',
        name: 'סיסמה קבועה',
        type: 'password',
        renew: true,
        validation: 'not-he',
      },
    },
    links: {
      homepage: 'https://www.bank-yahav.co.il',
      login: 'https://www.bank-yahav.co.il/Entrance.aspx',
      signup: 'https://register.yahav.co.il/IBAdmin-SelfRegistration/registrationINIT.action?hiddenstate=Self_Registration',
    },
    logoFile: 'yahav-large.jpg',
    type: 'bank',
    unsupported: true,
  },
  masad: {
    sourceName: 'מסד',
    displayName: 'מסד',
    backendName: 'massad',
    sortPriority: 50,
    fields: {
      username: {
        key: 'username',
        name: 'קוד משתמש',
        type: 'text',
        validation: 'min-length:4|not-he|not-special',
      },
      password: {
        key: 'password',
        name: 'סיסמה קבועה',
        type: 'password',
        renew: true,
        validation: 'min-length:6|not-he',
      },
    },
    links: {
      homepage: 'https://www.bankmassad.co.il',
      login: 'https://online.bankmassad.co.il/wps/portal/',
    },
    logoFile: 'massad-large.svg',
    type: 'bank',
  },
  pagi: {
    sourceName: 'פאגי',
    displayName: 'בנק פאגי',
    backendName: 'pagi',
    sortPriority: 50,
    fields: {
      username: {
        key: 'username',
        name: 'קוד משתמש',
        type: 'text',
        validation: 'min-length:4|not-he|not-special',
      },
      password: {
        key: 'password',
        name: 'סיסמה קבועה',
        type: 'password',
        renew: true,
        validation: 'min-length:6|not-he',
      },
    },
    links: {
      homepage: 'https://www.pagi.co.il',
      login: 'https://www.pagi.co.il/wps/portal/',
    },
    logoFile: 'pagi-large.png',
    type: 'bank',
  },
  beinleumi: {
    sourceName: 'הבינלאומי',
    displayName: 'הבינלאומי',
    backendName: 'benleumi',
    sortPriority: 30,
    fields: {
      username: {
        key: 'username',
        name: 'קוד משתמש',
        type: 'text',
        validation: 'min-length:4|not-he|not-special',
      },
      password: {
        key: 'password',
        name: 'סיסמה קבועה',
        type: 'password',
        renew: true,
        validation: 'min-length:6|not-he',
      },
    },
    links: {
      homepage: 'https://www.fibi.co.il',
      login: 'https://online.fibi.co.il/wps/portal/',
    },
    logoFile: 'habeinleumi-large.svg',
    type: 'bank',
  },
  otsar: {
    sourceName: 'אוצר החייל',
    displayName: 'אוצר החייל',
    backendName: 'otsar',
    sortPriority: 50,
    fields: {
      username: {
        key: 'username',
        name: 'קוד משתמש',
        type: 'text',
        validation: 'min-length:4|not-he|not-special',
      },
      password: {
        key: 'password',
        name: 'סיסמה קבועה',
        type: 'password',
        renew: true,
        validation: 'min-length:6|not-he',
      },
    },
    links: {
      homepage: 'https://www.bankotsar.co.il',
      login: 'https://online.bankotsar.co.il/wps/portal/',
    },
    logoFile: 'otsar-large.png',
    type: 'bank',
  },
  ubank: {
    sourceName: 'יובנק',
    displayName: 'יובנק',
    backendName: 'ubank',
    sortPriority: 50,
    fields: {
      username: {
        key: 'username',
        name: 'קוד משתמש',
        type: 'text',
        validation: 'min-length:4|not-he|not-special',
      },
      password: {
        key: 'password',
        name: 'סיסמה קבועה',
        type: 'password',
        renew: true,
        validation: 'min-length:6|not-he',
      },
    },
    links: {
      homepage: 'https://www.fibi.co.il/wps/portal/FibiMenu/Marketing/Platinum',
      login: 'https://www.fibi.co.il/wps/portal/FibiMenu/Marketing/Platinum',
    },
    logoFile: 'ubank-large.png',
    type: 'bank',
  },
  egud: {
    sourceName: 'אגוד',
    displayName: 'בנק אגוד',
    backendName: 'egudbank',
    sortPriority: 30,
    fields: {
      username: {
        key: 'username',
        name: 'זיהוי משתמש',
        type: 'text',
        validation: 'exact-length:7|not-he',
      },
      password: {
        key: 'password',
        name: 'סיסמה קבועה',
        type: 'password',
        renew: true,
        validation: 'min-length:6|not-he',
      },
    },
    links: {
      homepage: 'https://www.unionbank.co.il/igud/homepage/',
      login: 'https://hb.unionbank.co.il/H/Login.html',
    },
    logoFile: 'igud-large.svg',
    type: 'bank',
  },
  doar: {
    sourceName: 'הדואר',
    displayName: 'בנק הדואר',
    backendName: 'doar',
    sortPriority: 50,
    fields: {
      username: {
        key: 'username',
        name: 'שם משתמש',
        type: 'text',
        validation: 'not-he',
      },
      idNumber: {
        key: 'idNumber',
        name: 'מספר זהות',
        type: 'text',
        validation: 'id',
      },
      password: {
        key: 'password',
        name: 'סיסמה קבועה',
        type: 'password',
        renew: true,
        validation: 'not-he',
      },
    },
    links: {
      homepage: 'https://www.bankhadoar.co.il',
      login: 'https://www.bankhadoar.co.il/#/Login',
      signup: 'https://www.bankhadoar.co.il/#/Login/Register',
    },
    logoFile: 'doar-large.svg',
    type: 'bank',
  },
  pepper: {
    sourceName: 'פפר',
    displayName: 'פפר',
    waitingListName: 'Pepper',
    sortPriority: 100,
    links: {
      homepage: 'https://lp.pepper.co.il/',
    },
    logoFile: 'pepper-large.svg',
    type: 'bank',
    unsupported: true,
  },
  jerusalem: {
    sourceName: 'ירושלים',
    displayName: 'בנק ירושלים',
    waitingListName: 'Jerusalem Bank',
    sortPriority: 100,
    links: {
      homepage: 'https://www.bankjerusalem.co.il/',
    },
    logoFile: 'jerusalem-large.jpg',
    type: 'bank',
    unsupported: true,
  },
  isracard: {
    sourceName: 'ישראכארט',
    displayName: 'ישראכרט',
    backendName: 'isracard',
    fields: {
      idNumber: {
        key: 'idNumber',
        name: 'מספר תעודת זהות',
        type: 'text',
        validation: 'id',
      },
      last6digits: {
        key: 'last6digits',
        name: '6 ספרות אחרונות',
        type: 'text',
        validation: 'exact-length:6|only-digits',
      },
      password: {
        key: 'password',
        name: 'סיסמה קבועה',
        type: 'password',
        renew: true,
        validation: 'min-length:8',
      },
    },
    links: {
      homepage: 'https://www.isracard.co.il',
      login: 'https://digital.isracard.co.il/personalarea/Login/',
      signup: 'https://digital.isracard.co.il/personalarea/loginarea/#/Register',
      forgotPassword: 'https://digital.isracard.co.il/personalarea/loginarea/#/ForgotPassword',
    },
    logoFile: 'isracard-large.svg',
    instructions: 'Isracard.vue',
    logoFileStacked: 'isracard-stacked.svg',
    cardLogo: 'isracard.png',
    type: 'card',
  },
  cal: {
    sourceName: 'ויזה כאל',
    displayName: 'כאל / דיינרס',
    backendName: 'cal',
    fields: {
      username: {
        key: 'username',
        name: 'שם משתמש',
        type: 'text',
        validation: 'not-he',
      },
      password: {
        key: 'password',
        name: 'סיסמה קבועה',
        type: 'password',
        renew: true,
        validation: 'min-length:8|not-he',
      },
    },
    links: {
      homepage: 'https://www.cal-online.co.il',
      login: 'https://services.cal-online.co.il/Card-Holders/SCREENS/AccountManagement/Login.aspx?csrt=17535042919882254315&ReturnUrl=%2fCard-Holders%2fSCREENS%2fAccountManagement%2fcalposting.aspx%3futm_source%3dcm%26utm_medium%3dsms%26utm_campaign%3ddperut', // eslint-disable-line
      signup: 'https://services.cal-online.co.il/Card-Holders/SCREENS/AccountManagement/Joining.aspx',
      forgotPassword: 'https://services.cal-online.co.il/card-holders/Screens/AccountManagement/PasswordRestoring.aspx',
    },
    logoFile: 'cal-diners.png',
    instructions: 'Cal.vue',
    logoFileStacked: 'cal-diners-stacked.svg',
    cardLogo: 'diners_visacal.png',
    type: 'card',
  },
  leumicard: {
    sourceName: 'לאומי קארד',
    displayName: 'לאומי קארד max',
    backendName: 'leumicard',
    fields: {
      username: {
        key: 'username',
        name: 'שם משתמש',
        type: 'text',
        validation: 'not-he',
      },
      password: {
        key: 'password',
        name: 'סיסמה קבועה',
        type: 'password',
        renew: true,
        validation: 'min-length:8|not-he',
      },
    },
    links: {
      homepage: 'https://www.max.co.il',
      login: 'https://www.max.co.il/homepage/welcome',
      signup: 'https://online.max.co.il/Anonymous/Registration.aspx?SourceGA=PasswordLogin',
      forgotPassword: 'https://online.max.co.il/Anonymous/RecoverPassword.aspx?SourceGA=PasswordLogin',
    },
    logoFile: 'leumicard-max.png',
    instructions: 'Leumicard.vue',
    logoFileStacked: 'max-leumi-stacked.svg',
    cardLogo: 'leumicard.png',
    type: 'card',
  },
  amex: {
    sourceName: 'אמריקן אקספרס',
    displayName: 'אמריקן אקספרס',
    backendName: 'americanexpress',
    fields: {
      idNumber: {
        key: 'idNumber',
        name: 'מספר תעודת זהות',
        type: 'text',
        validation: 'id',
      },
      last6digits: {
        key: 'last6digits',
        name: '6 ספרות אחרונות',
        type: 'text',
        validation: 'exact-length:6|only-digits',
      },
      password: {
        key: 'password',
        name: 'סיסמה קבועה',
        type: 'password',
        renew: true,
        validation: 'min-length:8',
      },
    },
    links: {
      homepage: 'https://www.americanexpress.co.il',
      login: 'https://he.americanexpress.co.il/personalarea/login/',
      signup: 'https://he.americanexpress.co.il/personalarea/loginarea/#/Register',
      forgotPassword: 'https://he.americanexpress.co.il/personalarea/loginarea/#/ForgotPassword',
    },
    logoFile: 'amex-large.svg',
    instructions: 'Amex.vue',
    logoFileStacked: 'amex-stacked.svg',
    cardLogo: 'amex.png',
    type: 'card',
  },
};

export default {
  allSourceFields,
};
